export default class Menu {

    handleMenuMobile() {
        const menuToggler = document.querySelector(".navbar-toggler--closed");
        const menuTogglerOpened = document.querySelector(".navbar-toggler--opened");
        const menuHolder = document.querySelector(".navbar-collapse");
        const siteNavigation = document.querySelector("#site-navigation");
        const overlay = document.querySelector(".bg-overlay");

        function toggleMenu(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            menuToggler.classList.toggle("open");
            siteNavigation.classList.toggle("opened");
            overlay.classList.toggle("show");
            document.getElementsByTagName("html")[0].classList.toggle("hide");
            document.body.classList.toggle("hide");

            if (menuHolder !== null && menuHolder !== "undefined") {
                menuHolder.classList.toggle("collapse");
            }

        }

        if (menuToggler !== null && menuToggler !== "undefined") {
            menuToggler.addEventListener("click", e => {
                toggleMenu(e);
            });

            menuTogglerOpened.addEventListener('click', (e) => {
                toggleMenu(e);
            });

        }
    }

    handleSubmenu() {
        const menuItemsWithSubmenu = document.querySelectorAll('.nav-item.dropdown');
        if (menuItemsWithSubmenu && window.innerWidth >= 1200) {
            [...menuItemsWithSubmenu].forEach((item) => {
                item.addEventListener('mouseover', function () {
                    item.classList.add('hovered');
                })

                item.addEventListener('mouseleave', function () {
                    item.classList.remove('hovered');
                })
            });
        }

        if (menuItemsWithSubmenu && window.innerWidth < 1200) {
            [...menuItemsWithSubmenu].forEach((item) => {

                const submenu = item.querySelector('.active'); // Assuming you want to find an element with the class 'active' within the submenu.
                if (submenu) {
                    item.classList.add('clicked');
                }

                item.children[1].addEventListener('click', function () {
                    item.classList.toggle('clicked');
                })
            });
        }
    }

    handleMenuToggle() {
        const menuToggler = document.querySelector('.navbar-toggler');
        if (menuToggler) {
            menuToggler.addEventListener('click', function () {
                this.classList.toggle('open');

                const parentElement = this.parentElement;
                const siblings = Array.from(parentElement.parentElement.children).filter(element => element.classList.contains('navbar__items'));
                const mainMenuContainer = siblings[0].children[0];
                mainMenuContainer.classList.toggle('opened');
            });
        }
    }

    init() {
        // this.handleMenuMobile()
        this.handleSubmenu()
        this.handleMenuToggle()
    }
}
